import {
	type CommentaryTemplateDto,
	type SaveCommentaryTemplateDto,
	CommentaryTemplateControllerApiFactory,
} from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { axiosExtract } from "$root/third-party-integrations/axios";
import type { Abortable } from "@mdotm/utils/promise";
const storyfolioRepositoryBaseKeys = {
	list: "templates",
};

const { newQuery, newAction, invalidateEntity, invalidateLists } = repositoryHelperFactory("storyfolio", {
	listKeys: Object.values(storyfolioRepositoryBaseKeys),
});

const commentaryApi = () => getApiGen(CommentaryTemplateControllerApiFactory);

export const storyfolioRepository = {
	invalidateEntity,
	invalidateLists,

	templates: newQuery("templates", () => axiosExtract(commentaryApi().getTemplateList())),
	tonesOfVoice: newQuery("tonesOfVoice", () => axiosExtract(commentaryApi().getToneOfVoices())),
	languages: newQuery("languages", () => axiosExtract(commentaryApi().getLanguages())),

	/**
	 * `uuid` is the template being renamed, if any: the backend then reports its own current name as
	 * available, so an unchanged name doesn't read as taken.
	 */
	isCommentaryNameIsAvailable: newAction((name: string, opts?: Abortable & { uuid?: string }) =>
		// typo in backend method name
		axiosExtract(commentaryApi().isInvestmentNameAvailable1(name, opts?.uuid, opts)),
	),

	create: newAction(async (request: SaveCommentaryTemplateDto) => {
		const result = await axiosExtract(commentaryApi().createTemplate(request));
		invalidateLists();
		return result;
	}),
	update: newAction(async (uuid: string, request: CommentaryTemplateDto) => {
		const result = await axiosExtract(commentaryApi().updateTemplate(uuid, request));
		invalidateEntity(uuid);
		return result;
	}),
	delete: newAction(async (uuid: string) => {
		await axiosExtract(commentaryApi().deleteTemplate(uuid));
		invalidateLists();
	}),
} as const;
